import { useCallback } from 'react';

import { useSetMySkillLevelChoiceMutation } from 'core/graphql/generated/hooks';
import { evictVacancySkillMatch } from 'core/hooks/CareerCenter/evictVacancySkillMatch';

/**
 * Студент сам оценил уровень навыка (0072, шаг 3) — из паспорта навыка.
 *
 * 🔴 Перезапрашиваются ТОЛЬКО экраны, которые смонтированы рядом с паспортом:
 * маршрут (`CareerLayout`), карта под паспортом и сам паспорт. `refetchQueries`
 * по имени бьёт только активные запросы: пропущенный (`skip`) запрос отдал бы
 * 400, а несмонтированный — тихий no-op. Каталог профессий и CV обновятся сами
 * при переходе — они на `cache-and-network`. Соответствие вакансий (0073)
 * выбрасывается из кеша и пересчитается сервером при показе.
 *
 * → `true`, если сервер записал уровень.
 */
export const useSetMySkillLevel = () => {
  const [mutate, { loading }] = useSetMySkillLevelChoiceMutation({
    refetchQueries: ['CareerJourneyBoard', 'CareerSkillGraphBoard', 'CareerSkillDetail'],
    awaitRefetchQueries: true,
  });

  const setLevel = useCallback(
    async (skillId: string, level: number) => {
      try {
        const result = await mutate({
          variables: { skillId, level },
          update: (cache, { data }) => {
            if (data?.setMySkillLevel?.success) evictVacancySkillMatch(cache);
          },
        });
        return Boolean(result.data?.setMySkillLevel?.success);
      } catch {
        return false;
      }
    },
    [mutate],
  );

  return { setLevel, loading };
};
